export enum EsploroMetricSource {
    WoS = 'WOS',
    Scopus = 'Scopus',
    Microsoft = 'Microsoft',
    Google = 'Google',
}

export type EsploroMetricSourceCode =
    (typeof EsploroMetricSource)[keyof typeof EsploroMetricSource];
